import StyleProvider from '@sendsprint/ui-react/dist/providers/StyleProvider/StyleProvider';
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import {
  EnvProvider,
  AuthProvider,
  ToastProvider,
  DashboardProvider,
  NethoneProvider,
  LocationProvider
} from '@src/contexts';
import { ErrorBoundary } from '@sentry/react';
import QueryProvider from '@src/providers/query-provider';
import Error from '@src/pages/error';
import AppLayoutInner from './components/appLayoutInner';
import { Outlet } from 'react-router-dom';
import { getEnvData } from '@src/utils/env';
import { LoadScript } from '@react-google-maps/api';
import Loader from '@src/components/loader';
import { BusinessCheckProvider } from '@src/contexts/business-check-context';

const ENV_DATA = getEnvData();

const GOOGLE_MAPS_API_KEY = ENV_DATA.GOOGLE_MAPS_API_KEY;

const AppLayout = () => {
  return (
    <HelmetProvider>
      <StyleProvider>
        <EnvProvider>
          <LoadScript
            googleMapsApiKey={GOOGLE_MAPS_API_KEY}
            loadingElement={<Loader />}
            libraries={['places']}>
            <ErrorBoundary fallback={({ resetError }) => <Error resetError={resetError} />}>
              <ToastProvider autoDismiss={true} placement="bottom-right">
                <QueryProvider>
                  <AuthProvider>
                    <DashboardProvider>
                      {/* <LocationProvider> */}
                      <NethoneProvider>
                        <BusinessCheckProvider>
                          <AppLayoutInner>
                            <Outlet />
                          </AppLayoutInner>
                        </BusinessCheckProvider>
                      </NethoneProvider>
                      {/* </LocationProvider> */}
                    </DashboardProvider>
                  </AuthProvider>
                </QueryProvider>
              </ToastProvider>
            </ErrorBoundary>
          </LoadScript>
        </EnvProvider>
      </StyleProvider>
    </HelmetProvider>
  );
};

export default AppLayout;
